import { motion } from "framer-motion";
import { Layers, Gauge, ScrollText, Lock, Headphones, Network } from "lucide-react";

const reasons = [
  { icon: Network, title: "Direct + Network", body: "We fund you directly when it fits — and route to elite lenders when their product is sharper. You always get the best deal." },
  { icon: Gauge, title: "Decisions in Hours", body: "Most pre-approvals come back same-day. Funds wire within 24 hours of signed terms — often faster." },
  { icon: Layers, title: "Flexible Qualifications", body: "Bank turn-downs welcome. We underwrite on real-time revenue, not just FICO." },
  { icon: Lock, title: "No Hidden Fees", body: "Flat factor rates or APRs disclosed up front. No origination tricks. No surprise junk fees." },
  { icon: Headphones, title: "Dedicated Specialist", body: "One person owns your file from application to funded. No call-center maze." },
  { icon: ScrollText, title: "Repeat Funding", body: "60% of our clients come back. Bigger amounts, better terms, faster turnaround every time." },
];

const TEXTURE = "https://images.pexels.com/photos/12306417/pexels-photo-12306417.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1024&w=1536";

export default function WhyUs() {
  return (
    <section id="why" data-testid="why-us-section" className="relative py-24 md:py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{ backgroundImage: `url(${TEXTURE})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-[#050B14]/60" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-gold mb-5">Why DirectFundCap</div>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-white tracking-tighter">
              Built like a lender.<br />
              Priced like a marketplace.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-12">
            <p className="text-white/60 text-lg leading-relaxed">
              Most brokers shop your file to anyone who'll pay them. We don't.
              We start with our own capital, then tap a network of vetted lenders only when
              their terms beat ours. You get speed, transparency, and the sharpest deal —
              every time.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {reasons.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              data-testid={`why-${i}`}
              className="bg-[#050B14] p-8 md:p-10 hover:bg-[#0A1326] transition-colors group"
            >
              <r.icon className="w-7 h-7 text-gold mb-6 group-hover:scale-110 transition-transform" />
              <h3 className="font-heading text-xl text-white mb-3">{r.title}</h3>
              <p className="text-white/60 leading-relaxed text-sm">{r.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
